/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_Saved_PausedInputs */



/**
* | output |
* | --- |
* | "Saved. The space syncs with the new settings once it is active again." |
*
* @param {Spaces_Connection_Settings_Saved_PausedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_saved_paused = /** @type {((inputs?: Spaces_Connection_Settings_Saved_PausedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_Saved_PausedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeichert. Der Space wird mit den neuen Einstellungen synchronisiert, sobald er wieder aktiv ist.")
	return /** @type {LocalizedString} */ ("Saved. The space syncs with the new settings once it is active again.")
});